// https://observablehq.com/@mbostock/localized-number-parsing
class NumberParser {
	_group: RegExp;
	_decimal: RegExp;
	_numeral: RegExp;
	_index;

	constructor(locale: string) {
		const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
		const numerals = [
			...new Intl.NumberFormat(locale, { useGrouping: false }).format(
				9876543210,
			),
		].reverse();
		const index = new Map(numerals.map((d, i) => [d, i]));
		this._group = new RegExp(
			`[${parts.find((d) => d.type === "group")?.value}]`,
			"g",
		);
		this._decimal = new RegExp(
			`[${parts.find((d) => d.type === "decimal")?.value}]`,
		);
		this._numeral = new RegExp(`[${numerals.join("")}]`, "g");
		this._index = (d: string) => String(index.get(d));
	}

	parse(string?: string) {
		if (typeof string !== "string") {
			return undefined;
		}

		string = string
			.trim()
			.replace(this._group, "")
			.replace(this._decimal, ".")
			.replace(this._numeral, this._index);

		return string ? +string : NaN;
	}
}

const parser = new NumberParser("nl-NL");

export function useNumberParser() {
	return parser;
}
